import React, { useEffect, useState } from 'react';
import 'swagger-ui-react/swagger-ui.css';
import { Button, Icon, Typography, message, Tabs } from 'antd';
import { subscribe } from 'alfa';
import { withTranslation } from 'react-i18next';
import SwaggerUI from 'swagger-ui-react';

import APIKeyList from './components/list';
import APIKeyRepo from '../../repository/api-key';
import Link from '../../components/link';
import config from '../../config/config';
import ExamplesIndex from './components/examples';

const { Title } = Typography;

const APIKeyIndex = withTranslation()((props) => {
  const { business, t } = props;
  const [loading, setLoading] = useState(true);
  const [apikeys, setAPIKeys] = useState([]);

  useEffect(() => {
    const fetchCollectionInEffect = async () => {
      try {
        const { data: { keys } } = await APIKeyRepo.fetchCollection(business);
        setAPIKeys(keys);
      } catch (error) {
        console.error('ERROR: APIKeyIndex: APIKeyRepo.fetchCollection()', error); // eslint-disable-line no-console
        message.error(t('error.loading_api_keys'));
      } finally {
        setLoading(false);
      }
    };
    fetchCollectionInEffect();
  }, [business, t]);

  return (
    <>
      <Tabs defaultActiveKey="1" tabPosition="left">
        <Tabs.TabPane tab={t('api_keys')} key="api-keys">
          <Title level={3}>
            {t('api_keys')}
            <Button.Group style={{ float: 'right' }}>
              <Link button to="/api-keys/new"><Icon type="plus" /> {t('create_api_key')}</Link>
            </Button.Group>
          </Title>
          <APIKeyList loading={loading} keys={apikeys} />
        </Tabs.TabPane>

        <Tabs.TabPane tab={t('documentation')} key="docs">
          <SwaggerUI url={`${config.base_url}/spec.json`} />
        </Tabs.TabPane>

        <Tabs.TabPane tab={t('examples')} key="examples">
          <ExamplesIndex />
        </Tabs.TabPane>
      </Tabs>
    </>
  );
});

export default subscribe(APIKeyIndex, ['business']);
